module.exports = __webpack_public_path__ + "img/logo-yumiwi-horizontal-text.d5a76c86.svg";